import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLiveIndicator = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 9,
	height: 8,
	viewBox: "0 0 9 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 4.5,
			cy: 4,
			r: 2,
			fill: "url(#paint0_linear_8677_189446)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 4.5,
			cy: 4,
			r: 3.5,
			stroke: "url(#paint1_linear_8677_189446)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_8677_189446",
			x1: 6.5,
			y1: 4,
			x2: 2.5,
			y2: 4,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FF2882" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#FF6900"
			})]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_8677_189446",
			x1: 8.5,
			y1: 4,
			x2: .5,
			y2: 4,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FF2882" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#FF6900"
			})]
		})] })
	]
});
export default SvgLiveIndicator;
